import React from 'react';
import { Box, Typography } from '@mui/material';
import DummyBadge from '../../common/DummyBadge';
import { AnimatedNumber, growReveal } from './motion';

/** Optional stacked bar + one tile per stage (count). Used for the WO pipeline, tasks and aging. */
const StageTiles = ({ stages = [], showBar, onStage, columns }) => {
  const total = stages.reduce((s, x) => s + (Number(x.count) || 0), 0);
  return (
    <Box>
      {showBar && total > 0 && (
        <Box sx={{ display: 'flex', height: 12, borderRadius: 999, overflow: 'hidden', gap: '3px', mb: 2, ...growReveal() }}>
          {stages.filter((s) => Number(s.count) > 0).map((s) => <Box key={s.key} sx={{ flex: Number(s.count), bgcolor: s.color }} />)}
        </Box>
      )}
      <Box sx={{ display: 'grid', gridTemplateColumns: `repeat(${columns || stages.length}, minmax(0, 1fr))`, gap: 1.25 }}>
        {stages.map((s) => (
          <Box key={s.key} onClick={onStage ? () => onStage(s.key) : undefined}
            sx={{ borderRadius: '12px', p: 1.5, border: '1px solid', borderColor: 'divider', bgcolor: 'action.hover', cursor: onStage ? 'pointer' : 'default', minWidth: 0 }}>
            <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary', display: 'flex', alignItems: 'center', gap: 0.75 }} noWrap>
              <Box component="span" sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: s.color, flexShrink: 0 }} />
              {s.label}
              {s.demo && <DummyBadge label="Demo data — waits for the dashboard backend" />}
            </Typography>
            <Typography sx={{ fontSize: '1.375rem', fontWeight: 800 }}><AnimatedNumber value={s.count} /></Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default StageTiles;
